import React from 'react';
import { Drawer, FormVehicleType } from '../../components';
import { useStyles } from '../../services/material-ui';

const CreateVehicleType: React.FC = () => {
  const classes = useStyles();

  return (
    <div className="container-dash">
      <Drawer />
      <main className={classes.content}>
        <FormVehicleType />
      </main>
    </div>
  );
};

export default CreateVehicleType;
